import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HostPortalClient, User, Webinar, WebinarClient } from '../Services/WOWApi.Service';
import { Subscription } from 'rxjs';
import { CommonService } from '../Services/common.service';
import { CustomServiceService } from '../Services/custom-service.service';
import moment from 'moment';

@Component({
    selector: 'app-webinars',
    templateUrl: './webinars.component.html',
    styleUrls: ['./webinars.component.css'],
    standalone: false
})
export class WebinarsComponent implements OnInit, OnDestroy {
  webinars: Array<Webinar> | any;
  webinarId: number;
  showSpinner: boolean = false;
  outOfficeDays: string;
  showMessage: boolean = true;
  numberOfOOO: number = 0;
  isMobileView = false;
  subscription: Subscription;
  loggedUser: User;
  minHeight: number = 0;
  minHeightWebinaName = 0;
  webinarDivDisplay = 'none';
  allWebinars: Array<Webinar> = [];
  isLoggedInUserHostOrAdmin: boolean = false;
  latestWebinarId: number | null = null;
  
  constructor(private webinarClient: WebinarClient,
    private router: Router,
    private hostPortalClient: HostPortalClient,
    private route: ActivatedRoute,
    private customServices: CustomServiceService,
    private commonService: CommonService) {
    // Removed global spinner initialization for better UX
    // this.commonService.setSpinner(true);
    this.webinarId = this.route.snapshot.params.id;
  }

  ngOnInit(): void {
    this.loggedUser = this.customServices.GetLoggedInUser();
    if(this.loggedUser == null) {
      this.commonService.setUserHostOrAdmin(false);  
    }
    else if (this.loggedUser.isHost == true || this.loggedUser.isOwner == true) {
      this.commonService.setUserHostOrAdmin(true);  
    }
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
    this.subscription = this.commonService.isLoggedInUserHostOrAdmin.subscribe(res => this.isLoggedInUserHostOrAdmin = res);
    this.route.params.subscribe(routeParams => {
      this.webinarId = routeParams.id;
      this.loadDataAsync();
    });
    const routeParams = this.route.snapshot.params;    
  }

  private async loadDataAsync(): Promise<void> {
    // Load webinars and out of office data asynchronously
    const webinarsPromise = this.GetWebinarsAsync();
    const outOfOfficePromise = this.loggedUser?.id
      ? this.GetOutOfOfficeAsync(this.loggedUser.id)
      : Promise.resolve();
    
    // Don't wait for completion - let them run in background
    Promise.all([webinarsPromise, outOfOfficePromise]).catch(error => {
      console.error('Error in background API calls:', error);
    });
  }
  // Original synchronous method (kept for backward compatibility)
  GetWebinars() {
    this.showSpinner = true;
    this.webinarClient.getWebinars(this.webinarId).subscribe(data => {
      // Sort webinars by startDateTime descending (newest first)
      if (data && data.length > 0) {
        data = data.sort((a, b) => {
          const dateA = new Date(a.startDateTime).getTime();
          const dateB = new Date(b.startDateTime).getTime();
          return dateB - dateA; // Descending order (newest first)
        });
        
        // Find the webinar with the latest startDateTime (first one after sorting)
        this.latestWebinarId = data[0].webinarId;
      } else {
        this.latestWebinarId = null;
      }
      
      this.allWebinars = data;
      const formattedWebinars =  this.commonService.splitArrayIntoChunks(data,4 );
      this.webinars = formattedWebinars;
      if (!this.isMobileView) {
        setTimeout(() => {
          let heightSet = 0;
          let heightWebName = 0;
          this.webinars.map((webinar, i) => {
            webinar.map((web, j) => {
              const ele = document.getElementById('webinar_' + i + '_' + j);
              const eleName = document.getElementById('webinarName_' + i + '_' + j);
              if ( ele.offsetHeight > heightSet) {
                heightSet = ele.offsetHeight;
              }
              if ( eleName.offsetHeight > heightWebName) {
                heightWebName = eleName.offsetHeight;
              }
            });
          });
          this.minHeight = heightSet;
          this.minHeightWebinaName = heightWebName;
        }, 100);
      }
      this.webinars = [];
      this.webinars = formattedWebinars;
      this.webinarDivDisplay = 'block';

      this.showSpinner = false;
      if (this.webinars.length > 0)
        this.GetOutOfOffice(this.loggedUser.id);
    }, error => { this.showSpinner = false; });
  }

  // New asynchronous method without loading indicators
  private async GetWebinarsAsync(): Promise<void> {
    try {
      let data = await this.webinarClient.getWebinars(this.webinarId).toPromise();
      
      // Sort webinars by startDateTime descending (newest first)
      if (data && data.length > 0) {
        data = data.sort((a, b) => {
          const dateA = new Date(a.startDateTime).getTime();
          const dateB = new Date(b.startDateTime).getTime();
          return dateB - dateA; // Descending order (newest first)
        });
        
        // Find the webinar with the latest startDateTime (first one after sorting)
        this.latestWebinarId = data[0].webinarId;
      } else {
        this.latestWebinarId = null;
      }
      
      this.allWebinars = data;
      const formattedWebinars = this.commonService.splitArrayIntoChunks(data, 4);
      this.webinars = formattedWebinars;
      
      if (!this.isMobileView) {
        setTimeout(() => {
          let heightSet = 0;
          let heightWebName = 0;
          this.webinars.map((webinar, i) => {
            webinar.map((web, j) => {
              const ele = document.getElementById('webinar_' + i + '_' + j);
              const eleName = document.getElementById('webinarName_' + i + '_' + j);
              if (ele && ele.offsetHeight > heightSet) {
                heightSet = ele.offsetHeight;
              }
              if (eleName && eleName.offsetHeight > heightWebName) {
                heightWebName = eleName.offsetHeight;
              }
            });
          });
          this.minHeight = heightSet;
          this.minHeightWebinaName = heightWebName;
        }, 100);
      }
      
      this.webinars = [];
      this.webinars = formattedWebinars;
      this.webinarDivDisplay = 'block';
    } catch (error) {
      console.error('Error loading webinars:', error);
    }
  }
  // Original synchronous method (kept for backward compatibility)
  GetOutOfOffice(userId: number) {
    this.outOfficeDays = '';
    this.hostPortalClient.getOutOfOffice(userId,false).subscribe(data => {
      this.numberOfOOO = 0;
      var currentDate = new Date(moment(new Date()).startOf('day').format('YYYY-MM-DD HH:mm:ss'));
      this.showMessage = data.filter(x => x.date >  currentDate).length > 0
      data = data.filter(x => x.date.getTime() >=  currentDate.getTime());
      for (let i = 0; i < data.length; i++) {
        this.numberOfOOO = this.numberOfOOO + 1;
        const date =
          ("00" + (data[i].date.getMonth() + 1)).slice(-2) +
          "/" +
          ("00" + data[i].date.getDate()).slice(-2);
        let char = ', ';
        if (i == 0) {
          char = "";
        }
        else if (i == data.length - 1) {
          char = " and "
        }
        this.outOfficeDays = this.outOfficeDays + char + date;
      }


    });
  }

  // New asynchronous method without loading indicators
  private async GetOutOfOfficeAsync(userId: number): Promise<void> {
    try {
      const data = await this.hostPortalClient.getOutOfOffice(userId, false).toPromise();
      this.outOfficeDays = '';
      this.numberOfOOO = 0;
      var currentDate = new Date(moment(new Date()).startOf('day').format('YYYY-MM-DD HH:mm:ss'));
      this.showMessage = data.filter(x => x.date > currentDate).length > 0;
      const filteredData = data.filter(x => x.date.getTime() >= currentDate.getTime());
      
      for (let i = 0; i < filteredData.length; i++) {
        this.numberOfOOO = this.numberOfOOO + 1;
        const date =
          ("00" + (filteredData[i].date.getMonth() + 1)).slice(-2) +
          "/" +
          ("00" + filteredData[i].date.getDate()).slice(-2);
        let char = ', ';
        if (i == 0) {
          char = "";
        }
        else if (i == filteredData.length - 1) {
          char = " and ";
        }
        this.outOfficeDays = this.outOfficeDays + char + date;
      }
    } catch (error) {
      console.error('Error loading out of office data:', error);
    }
  }
  OpenWebinar(webinarId: number) {
    this.router.navigate(["/Webinar", webinarId]);
  }

  formatPrice(value: number | string | null | undefined): string {
    const amount = Number(value);
    if (!Number.isFinite(amount)) {
      return '$0';
    }
    return amount % 1 === 0 ? `$${amount}` : `$${amount.toFixed(2)}`;
  }

  isFree(webinar: Webinar): boolean {
    return !!webinar?.isFreeBee || Number(webinar?.pricePerSeat) === 0;
  }

  displayPrice(webinar: Webinar): string {
    return this.isFree(webinar) ? 'FREE' : this.formatPrice(webinar?.pricePerSeat);
  }

  priceAmount(webinar: Webinar): string {
    if (this.isFree(webinar)) {
      return 'FREE';
    }
    const amount = Number(webinar?.pricePerSeat);
    if (!Number.isFinite(amount)) {
      return '0';
    }
    return amount % 1 === 0 ? `${amount}` : amount.toFixed(2);
  }

  isFeatured(webinar: Webinar): boolean {
    return this.isFree(webinar) || webinar?.webinarId === this.latestWebinarId;
  }

  seatFill(webinar: Webinar): number {
    const total = Number(webinar?.numberOfSeats) || 0;
    const left = Number(webinar?.seatsLeft) || 0;
    if (total <= 0) {
      return 0;
    }
    return Math.max(0, Math.min(100, (left / total) * 100));
  }

  isLowSeats(webinar: Webinar): boolean {
    const left = Number(webinar?.seatsLeft) || 0;
    const total = Number(webinar?.numberOfSeats) || 0;
    if (left <= 0) {
      return false;
    }
    return left <= 5 || (total > 0 && left / total <= 0.2);
  }

  isSoldOut(webinar: Webinar): boolean {
    return (Number(webinar?.seatsLeft) || 0) <= 0;
  }

  seatsLeftLabel(webinar: Webinar): string {
    return `${webinar?.seatsLeft ?? 0} of ${webinar?.numberOfSeats ?? 0} seats open`;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  webinarDescription(desc: string) {
    if (desc.split('-')[2] === undefined || desc.split('-')[1].length > 40) {
      const firstHalf = desc.substring(0, 35);
      const secondHalf = desc.substring(35);
      desc = firstHalf + ' ' + secondHalf;
    }
    if (desc !== null && desc.length > 70) {
      return desc.slice(0, 70);
    } else  {
      const description = (desc !== null && desc !== '') ? desc : 'Nil';
      return description;
    }
  }
}
